import { schema } from "normalizr";
import pointSchema from "./point";
import driverSchema from "./driver";

const pageResultsSchema = new schema.Entity(
    "pageResults",
    {
        points: [pointSchema],
        drivers: [driverSchema]
    },
    {
        idAttribute: "pageId"
    }
);

export default pageResultsSchema;



// WEBPACK FOOTER //
// ./src/schemas/page-results.js